var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHbA1C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    rx: 10,
    fill: "#6D5FF2",
    fillOpacity: 0.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1898_9494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 14.77L22.25 15.61C22.25 15.61 20.97 17.06 19.68 18.94C18.39 20.82 17 23.07 17 25.23C17 26.8213 17.6321 28.3474 18.7574 29.4727C19.8826 30.5979 21.4087 31.23 23 31.23C24.5913 31.23 26.1174 30.5979 27.2426 29.4727C28.3679 28.3474 29 26.8213 29 25.23C29 23.07 27.61 20.82 26.32 18.94C25.03 17.06 23.75 15.61 23.75 15.61L23 14.77ZM23 17.9C23.44 18.42 23.84 18.85 24.68 20.07C25.89 21.83 27 24.07 27 25.23C27 27.45 25.22 29.23 23 29.23C20.78 29.23 19 27.45 19 25.23C19 24.07 20.11 21.83 21.32 20.07C22.16 18.85 22.56 18.42 23 17.9Z",
    fill: "#6D5FF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1898_9494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbA1C);
export default __webpack_public_path__ + "static/media/HbA1c.8c8eea0c8c2055c598881d7338da9ca9.svg";
export { ForwardRef as ReactComponent };